import React, { useState } from "react";
import { useForm } from "react-hook-form";
import CheckCircleIcon from "components/Icon/CheckCircleIcon";
import EmailIcon from "@mui/icons-material/Email";

import SuiTypography from "components/SuiTypography";
import SuiInput from "components/SuiInput";
import SuiButton from "components/SuiButton";
import toast from "react-hot-toast";

import api from "services/api";

const checkMail = /^\S+@\S+$/i;

const VerifyEmailCard = ({ goBack, email }) => {
  const [unrecognizedEmail, setUnrecognizedEmail] = useState(false);
  const [mailSent, setSentMail] = useState(false);
  const { register, handleSubmit } = useForm({
    defaultValues: { email },
  });

  const onSubmit = async (values) => {
    if (!email) {
      return toast.error("Could not found the email!");
    }

    setUnrecognizedEmail(false);
    try {
      await api.sendConfirmEmail.resendVerificationEmail({ email: email });
      setSentMail(true);
    } catch (err) {
      toast.error("Send reset-password email failed!");
      setUnrecognizedEmail(true);
    }
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <div className="flex flex-col items-center">
        <SuiTypography variant="h4" fontWeight="medium" textTransform="capitalize">
          Verify your email address
        </SuiTypography>
        <SuiTypography variant="button" color="text" fontWeight="regular" className="my-4">
          Please check your email to finish the verification process.
          <br />
          If you are having trouble receiving the verification email, please click resend.
        </SuiTypography>

        {!mailSent ? (
          <>
            <SuiInput
              className="mb-0 mt-xlarge"
              readOnly={email ? true : false}
              type="email"
              placeholder="Email"
              size="large"
              {...register("email")}
            />

            {unrecognizedEmail && (
              <div className="mt-xsmall w-[318px]">
                <SuiTypography variant="button" color="error" fontWeight="regular" className="my-4">
                  We can't find a user with that email address!
                </SuiTypography>
              </div>
            )}

            <SuiButton
              className="w-[320px] h-[48px] mt-6 px-4"
              variant="gradient"
              color="dark"
              type="submit"
            >
              Resend
            </SuiButton>
          </>
        ) : (
          <div className="rounded-rounded p-base flex gap-x-small mt-large">
            <div className="flex flex-col gap-y-2xsmall">
              <SuiTypography
                variant="h6"
                fontWeight="medium"
                className="flex items-center"
                color="success"
              >
                <CheckCircleIcon size={20} />
                The email has been successfully sent!
              </SuiTypography>
              <SuiTypography variant="button" color="text" fontWeight="regular">
                Please follow the email instructions to finish your registration process.
                <br /> If you haven’t received the email after a few minutes, please check your spam
                folder.
              </SuiTypography>
            </div>
          </div>
        )}
        {goBack ? (
          <SuiTypography
            variant="button"
            fontWeight="medium"
            onClick={goBack}
            className="mt-8 cursor-pointer hover:underline"
          >
            Go back to sign in
          </SuiTypography>
        ) : null}
      </div>
    </form>
  );
};

export default VerifyEmailCard;
